var CryptoJS = require("crypto-js");

function encrypt(clientSecretId){
    return CryptoJS.AES.encrypt(clientSecretId, 'clientSecretId').toString();
}

module.exports = encrypt;